<template>
  <div v-if="data && data.length" class="switch-mode">
    <template v-for="(mode, index) in data">
      <span
        :class="{ 'mode-label': true, active: mode.value === value }"
        @click.prevent="$emit('on-change', mode.value)"
      >
        {{ mode.label }}
      </span>
      <span v-if="index < data.length - 1" class="divider">|</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'SwitchMode',
  props: ['data', 'value'],
  model: {
    prop: 'value',
    event: 'on-change'
  }
}
</script>
<style lang="less" type="text/less">
@import '~uikit';
.switch-mode {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .mode-label {
    cursor: pointer;
    line-height: 1.4;
    font-size: 14px;
    color: @light-grey;
    &.active {
      color: @black;
    }
  }
  .divider {
    line-height: 1;
    margin: 0 5px;
  }
}
</style>
